import type { RecipeIngredient } from '../../types';

export interface RecipeFormData {
  name: string;
  description: string;
  type: 'finished' | 'sub-recipe' | 'component';
  category: string;
  cuisine: string;
  servings: number;
  servingSize: string;
  prepTime: number;
  cookTime: number;
  yield: number;
  yieldUnit: string;
  difficulty: 'easy' | 'medium' | 'hard';
  ingredients: RecipeIngredient[];
  subRecipeIds: string[];
  instructions: string[];
  allergens: string[];
  dietaryFlags: string[];
}

export const emptyFormData: RecipeFormData = {
  name: '',
  description: '',
  type: 'finished',
  category: '',
  cuisine: '',
  servings: 4,
  servingSize: '',
  prepTime: 0,
  cookTime: 0,
  yield: 4,
  yieldUnit: 'portions',
  difficulty: 'medium',
  ingredients: [],
  subRecipeIds: [],
  instructions: [''],
  allergens: [],
  dietaryFlags: [],
};

export type TabId = 'basic' | 'ingredients' | 'instructions' | 'metadata';
